import React from 'react';
import { getBase64 } from '../../utils/fileHelper';

const CustomFileInput = ({ input, outputBase64, meta, 'data-cy': dataCy, accept }) => {
    const onFileChange = async (e) => {
        const inputFile = e.target.files;
        const targetFile = inputFile[0];
        if (targetFile) {
            const fileSize = targetFile.size;
            const fileName = targetFile.name;
            const fileExtension = fileName.split('.').pop();

            if (outputBase64) {
                const base64String = await getBase64(targetFile);
                input.onChange({
                    base64: base64String,
                    fileName: fileName,
                    size: fileSize,
                    type: fileExtension,
                });
            } else {
                input.onChange({
                    file: targetFile,
                    fileName: fileName,
                    size: fileSize,
                    type: fileExtension,
                });
            }
        } else {
            input.onChange(null);
        }
    };

    return (
        <div className="form__form-group-input-wrap">
            <div
                style={{
                    outline: '3px dotted rgba(28,110,164,0.5)',
                    outlineOffset: '13px',
                    marginLeft: '15px',
                    width: '90%',
                    textAlign: 'center',
                    marginBottom: '20px',
                }}
            >
                <input
                    name={input.name}
                    type="file"
                    onChange={onFileChange}
                    className="material-form__field"
                    data-cy={dataCy}
                    accept={accept || undefined}
                />
            </div>
            {meta.error && meta.touched && (
                <span
                    className="form__form-group-error margin-top-10"
                    data-cy={`${dataCy}--error`}
                >
                    {meta.error}
                </span>
            )}
        </div>
    );
};

CustomFileInput.defaultProps = {
    outputBase64: false,
    meta: {
        touched: false,
        error: '',
    },
    'data-cy': undefined,
};

export default CustomFileInput;
